import { Link } from "react-router-dom";
import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomeFranchise() {
  const { franchise } = homePage;
  return (
    <ScrollReveal delay={100}>
      <section className="py-16 md:py-20 bg-redbean-cream">
        <div className="mx-auto px-4 md:px-6 lg:px-8" style={{ maxWidth: "1200px" }}>
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left: Text */}
            <div className="flex-1 text-center lg:text-left">
              <h2
                className="font-heading font-bold text-redbean-coffee mb-5 text-balance"
                style={{ fontSize: "clamp(1.5rem, 3vw, 2.125rem)", lineHeight: 1.4 }}
              >
                {franchise.title}
              </h2>
              <p
                className="text-redbean-coffee/65 mb-8 max-w-lg mx-auto lg:mx-0"
                style={{ fontSize: "1.1875rem", lineHeight: 1.75 }}
              >
                {franchise.desc}
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8">
                {franchise.bullets.map((bullet, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-4 py-2 bg-redbean-lightcream text-redbean-coffee text-sm font-medium rounded-full"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-redbean-primary">
                      <i className="ri-check-line" />
                    </span>
                    {bullet}
                  </span>
                ))}
              </div>
              <Link
                to="/franchise"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-redbean-primary text-redbean-cream font-semibold rounded-full hover:bg-redbean-coffee transition-colors whitespace-nowrap text-[1.0625rem]"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-store-3-line" />
                </span>
                {franchise.cta}
              </Link>
            </div>

            {/* Right: Image */}
            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="rounded-card overflow-hidden shadow-card" style={{ height: "360px" }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Taiwanese%20night%20market%20food%20stall%20selling%20freshly%20made%20taiyaki%20red%20bean%20cakes%20warm%20string%20lights%20vendor%20working%20at%20griddle%20cozy%20warm%20atmosphere%20food%20photography%20golden%20amber%20lighting%20entrepreneurial%20small%20business%20inviting%20street%20food%20scene&width=800&height=600&seq=home-fr-1&orientation=landscape"
                  alt="紅豆餅加盟創業市集擺攤場景"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}